import { Outlet } from "react-router";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { useIsProvisioner } from "../../authn";
import { UnauthorizedMessage } from "../../shared/components";
import { useAgenticPlatformEnabled } from "../hooks";

export function AgentCatalogLayout() {
  const isProvisioner = useIsProvisioner();
  const agenticPlatformEnabled = useAgenticPlatformEnabled();

  if (!agenticPlatformEnabled || !isProvisioner) {
    return (
      <WorkspaceScreen>
        <UnauthorizedMessage />
      </WorkspaceScreen>
    );
  }

  return (
    <WorkspaceScreen wide>
      <Outlet />
    </WorkspaceScreen>
  );
}
